"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
exports.theme = {
  breakpoints: {
    100: "240px",
    200: "360px",
    300: "480px",
    400: "600px",
    500: "720px",
    600: "840px",
    700: "960px",
    750: "1020px",
    800: "1080px",
    900: "1200px"
  },
  colors: {
    brand: {
      100: "#191A9B",
      200: "#2527BC",
      300: "#2C2EE0",
      400: "#2F51F8",
      500: "#3C5DFF",
      600: "#7C93FF",
      700: "#BFCAFF",
      800: "#EBEFFF",
      900: "#FAFBFF"
    },
    white: {
      100: "#D0D0D4",
      300: "#E4E4E6",
      500: "#F0F1F2",
      600: "#F4F4F5",
      700: "#F7F7FA",
      800: "#FBFBFC",
      900: "#FFFFFF"
    },
    gray: {
      50: "#F9FAFB",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#2E2E39",
      400: "#32383E",
      500: "#4D555B",
      600: "#52585E",
      700: "#656A6F",
      800: "#8E8E9B",
      900: "#9999A5"
    },
    black: {
      100: "#000000",
      300: "#232624"
    },
    red: {
      100: "#A50C3F",
      200: "#FECACA",
      300: "#DB0F53",
      400: "#F87171",
      500: "#E5145A",
      600: "#DC2626",
      700: "#B91C1C",
      800: "#991B1B",
      900: "#ffeef0"
    },
    yellow: {
      100: "#D7AF00",
      200: "#FEF08A",
      300: "#E9C31D",
      400: "#FFD82B",
      500: "#FFE81C",
      600: "#F59E42",
      700: "#FFF069",
      800: "#CA8A04",
      900: "#FFF59C"
    },
    green: {
      100: "#0EA35F",
      200: "#BBF7D0",
      300: "#05C476",
      400: "#4ADE80",
      500: "#17DC83",
      600: "#22C55E",
      700: "#16A34A",
      800: "#166534",
      900: "#D0EFE1",
      1000: "#E6FFED"
    },
    purple: {
      50: "#FAF5FF",
      100: "#F3E8FF",
      200: "#E9D5FF",
      300: "#682DC7",
      400: "#7A39E3",
      500: "#9350FF",
      600: "#7C3AED",
      700: "#6D28D9",
      800: "#5B21B6",
      900: "#F0E6FF"
    },
    orange: {
      100: "#FFF7ED",
      200: "#FFEDD5",
      300: "#FED7AA",
      400: "#F66161",
      500: "#FF863B",
      600: "#EA580C",
      700: "#B45309",
      800: "#9A3412",
      900: "#7C4A03"
    },
    pink: {
      300: "#CA4972",
      500: "#F65C8C"
    }
  },
  effects: {
    shadow: {
      300: "0 2px 4px 0 rgba(228,228,230,1)",
      350: "0 4px 16px 0 rgba(228,228,230,1)"
    }
  }
};